import React from 'react';
import useStyle from './formSignUp.style';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { TextInput } from 'components/atoms/Inputs/TextInput';
import { LabelWithoutBG } from 'components/atoms/Label/Label.stories';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { Switch } from 'components/atoms/Buttons/Switchs/Switch';
import { ErrorsForm } from 'types/forms/form.def';
import { ProfParamsForm } from 'types/user/prof.def';

export interface FormSignUpProps {
  values: ProfParamsForm;
  handleChange: (e: any) => void;
  handlePolicy: (value: boolean) => void;
  submit: () => Promise<void>;
  errors: ErrorsForm;
  loading: boolean;
}

export const FormSignUp = ({
  values,
  handleChange,
  handlePolicy,
  submit,
  errors,
  loading
}: FormSignUpProps) => {
  const classes = useStyle();
  return (
    <FeatureContainer>
      <div className={classes.root}>
        <div className={classes.inputs}>
          <div>
            <LabelWithoutBG text={'Prénom'} />
            <TextInput
              name={'firstname'}
              onChange={handleChange}
              value={values.firstname || ''}
              placeHolder="ex: Léo..."
              requiredValue={true}
            />
            <p className={classes.inputError}>
              {errors.firstname && errors.firstname}
            </p>
          </div>
          <div>
            <LabelWithoutBG text={'Nom'} />
            <TextInput
              name={'lastname'}
              onChange={handleChange}
              value={values.lastname || ''}
              placeHolder="ex: Dubois..."
              requiredValue={true}
            />
            <p className={classes.inputError}>
              {errors.lastname && errors.lastname}
            </p>
          </div>
          <div>
            <LabelWithoutBG text={'Email'} />
            <TextInput
              name={'email'}
              onChange={handleChange}
              value={values.email || ''}
              placeHolder="ex: leo.d@mail.co..."
              requiredValue={true}
            />
            <p className={classes.inputError}>{errors.email && errors.email}</p>
          </div>
          <div>
            <LabelWithoutBG text={'Téléphone'} />
            <TextInput
              name={'tel'}
              onChange={handleChange}
              value={values.tel || ''}
              placeHolder="ex: 0790670909"
              requiredValue={true}
            />
            <p className={classes.inputError}>{errors.tel && errors.tel}</p>
          </div>
          <div className={classes.policy}>
            <p>
              Je reconnais avoir pris connaissance des{' '}
              <a
                className={classes.link}
                href="https://drive.google.com/file/d/1FpL0Wzhz5ULP70c5tGC_Ipoh8c8q3xyj/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                conditions générales d'utilisation
              </a>{' '}
              et je les accepte.
            </p>
            <div>
              <Switch defaultValue={values.policy} onClick={handlePolicy} />
            </div>
          </div>
        </div>
        <div className={classes.buttons}>
          <ButtonWithText
            content="Envoyer"
            onClick={submit}
            loading={loading}
            disabled={
              !values.policy ||
              errors.email ||
              errors.firstname ||
              errors.lastname ||
              errors.tel
            }
          />
        </div>
      </div>
    </FeatureContainer>
  );
};
